<template>
	<div class="">
		<router-view @childrenRoute="hideNonChildren" />
		<div class="row" v-if="hasPageChild==0" >
			<div class="col-md-12">
				<div class="row">
					<div class="col-md-6">
						<ListCompare title="SALES" unit="B" div=1000000000 :data="ytd.sales.rekap" itemcol="Info" valuecol="Value" url="/bright/sales"/>
					</div>
					<div class="col-md-6">
						<ListCompare title="LOSSES" unit="M" div=1000000 :data="ytd.losses.rekap" itemcol="Info" valuecol="Value" comp=-1 url="/bright/sales"/>
					</div>
				</div>
				<div class="row">
					<div class="col-md-6">
						<ListCompare title="SPD" unit="M" div=1000000 :data="ytd.sales.spd" itemcol="Info" valuecol="Value" url="/bright/sales"/>
					</div>
					<div class="col-md-6">
						<ListCompare title="MARGIN" unit="%" :data="ytd.margin.rekap" itemcol="Info" valuecol="Value" url="/bright/sales"/>
					</div>
				</div>

				<div class="row">
					<div class="col-md-6 mb-4">
						<BarCard title="SALES WEEKLY (M)" :data="sales.weekly" :width="500" :height="400" v-if="showchartcafe"/>
					</div>
					<div class="col-md-6 mb-4">
						<BarCard title="MARGIN WEEKLY (M)" :data="margin.weekly" :width="500" :height="400" v-if="showchartcafe"/>
					</div>
				</div>

				<div class="row" v-if="false">
					<div class="col-md-6">
						<BarCard title="SALES YTD (B)" :data="ytd.sales.ytdchart" :width="500" :height="280" url="/bright/sales"/>
					</div>
					<div class="col-md-6">
						<BarCard title="SALES MTD (B)" :data="ytd.sales.mtdchart" :width="500" :height="280" url="/bright/sales"/>
					</div>
					<div class="col-md-6">
						<BarCard title="MARGIN YTD (%)" :data="ytd.margin.ytdchart" :width="500" :height="280" url="/bright/sales"/>
					</div>
					<div class="col-md-6">
						<BarCard title="MARGIN MTD (%)" :data="ytd.margin.mtdchart" :width="500" :height="280" url="/bright/sales"/>
					</div>
				</div>				
			</div>
			<div class="col-md-4" v-if="false">
				<div class="row">
					<ListItem title="CAFE BY AREA" prefix="AREA" :data="store.area" itemcol="SalesArea" valuecol="StoreCnt"/>
					<ListItem title="CAFE BY PROVINCE" :data="store.province" itemcol="ProvinceName" valuecol="StoreCnt"/>
				</div>
			</div>
		</div>
		<Footer/>
	</div>
</template>

<script>
import Cafe from '@/components/page/Cafe.js'
import { Rainbow, Rainbow2, AppColors, Penanggalan, AxiosWithJar,Config } from '@/utility.js'
import BarCard from '@/views/pages/BarCard.vue'
import ListItem from '@/views/pages/ListItem.vue'
import ListCompare from '@/views/pages/ListCompare.vue'
import Footer from '@/views/Footer.vue'

export default{
	extends: Cafe,
	components:{
		ListItem,
		ListCompare,
		BarCard,
		Footer            
	},
	props: {
        plant: {
            type: String,
            default: '',
            //required: false,
        },
        branchid: {
            type: String,
            default: '',
            //required: false,
        },
		showchartcafe: {
			type: Boolean,
			default: false,
		},
    },
	data() {
		return {
			//branchid: this.cafeid,
			ytd: {
				sales:{rekap:[], spd:[], ytdchart:{}, mtdchart:{}, spdchart:{}}, 
				margin:{rekap:[], ytdchart:{}, mtdchart:{}}, 
				losses:{rekap:[], ytdchart:{}, mtdchart:{}}, 
				basket:{invoice:[], size:[]}, 
			},
			store: {area:[], province:[], list:[]},
			sales: { weekly:{} },
			margin: { weekly:{} },

			stacked: false,
		}
	},
	watch:{
		branchid() { //(newVal, oldVal) {
			this.loadYTD();
			this.loadSalesYTD();
		}
	},
    mounted()
	{
		//this.loadYTD();
    },
    methods:{
		async loadYTD() {
			let url = Config().apiURL + "/cafe/ytd?" + (this.branchid ? "&branchid=" + this.branchid : "") + (this.branchid ? "&plant=" + this.plant : "")
			await AxiosWithJar().get(url).then(result => {
				//console.log('ytd cafe: '+ JSON.stringify(result.data))
				if (result.data.sales.length) {
					this.ytd.sales = {
						rekap: this.processYTD(result.data.sales, "Info", "SalesExTax", false, "Grup", 1, 2),
						spd: this.processYTD(result.data.sales, "Info", "SalesExTax", "StoreCount", "Grup", 1, 2, false, false, "NumDay"),
						ytdchart: this.processBarChart(result.data.sales, "Info", "", "SalesExTax", false, "SalesArea", "AREA ", 1000000000, 2, Rainbow, "Grup", [1], true),
						mtdchart: this.processBarChart(result.data.sales, "Info", "", "SalesExTax", false, "SalesArea", "AREA ", 1000000000, 2, Rainbow2, "Grup", [2], true),
						spdchart: this.processBarChart(result.data.sales, "Info", "", "SalesExTax", "StoreCount", "SalesArea", "AREA ", 1000000, 2, Rainbow, "Grup", [4], true, false, "NumDay"),
					};
					this.ytd.margin = {
						rekap: this.processYTD(result.data.margin, "Info", "Margin", "SalesExTax", "Grup", 0.01, 2),
						ytdchart: this.processBarChart(result.data.margin, "Info", "", "Margin", "SalesExTax", "SalesArea", "AREA ", 0.01, 2, Rainbow, "Grup", [1], true),
						mtdchart: this.processBarChart(result.data.margin, "Info", "", "Margin", "SalesExTax", "SalesArea", "AREA ", 0.01, 2, Rainbow2, "Grup", [2], true),
					};
					this.ytd.losses = {
						rekap: this.processYTD(result.data.losses, "Info", "Losses", false, "Grup", 1, 2),
						ytdchart: this.processBarChart(result.data.losses, "Info", "", "Losses", false, "SalesArea", "AREA ", 1000000, 2, Rainbow, "Grup", [1], true),
						mtdchart: this.processBarChart(result.data.losses, "Info", "", "Losses", false, "SalesArea", "AREA ", 1000000, 2, Rainbow2, "Grup", [2], true),
					};
					this.ytd.basket = {
						invoice: this.processYTD(result.data.basket, "Info", "NoOfInvoice", false, "Grup", 1, 2),
						size: this.processYTD(result.data.basket, "Info", "SalesExTax", "NoOfInvoice", "Grup", 1, 2, false),
					};
				
				}

				//console.log('ytd sales : ' + JSON.stringify(result.data.sales))
				//console.log('ytd sales cafe ALL: ' + JSON.stringify(this.ytd.sales.rekap))
				//console.log('ytd sales cafe: ' + JSON.stringify(this.ytd.sales.rekap[3]))

				//console.log('ytd losses cafe ALL: ' + JSON.stringify(this.ytd.losses.rekap))
			})
		},

		async loadSalesYTD(){
			let url =Config().apiURL+"/cafe/sales?period=daily&detail=store"
				url += "&date-range-start="+Penanggalan().mingguSekarang
				url += "&date-range-end="+Penanggalan().kemarin
				url += (this.plant ? "&plant=" + this.plant : "") + (this.branchid ? "&branchid=" + this.branchid : "");
			await AxiosWithJar().get(url).then(result=>{
				if(result.data.data) {
					/*
					this.sales.weekly = this.processBarChart2(result.data.data, 'BranchName', 'TotalSalesExTax', false, 'Period', 1000, 2, AppColors, 
						false, false, false, true, false, false, false, true);
					*/
					this.sales.weekly = this.processBarChart(result.data.data, "BranchName", "SALES ", "TotalSalesExTax", false, "Period", "", 1000, 2, AppColors, false, false, false, this.stacked);

					/*
					this.margin.weekly = this.processBarChart2(result.data.data, 'BranchName', 'TotalMargin', false, 'Period', 1000, 2, AppColors, 
						false, false, false, true, false, false, false, true);
					*/
					this.margin.weekly = this.processBarChart(result.data.data, "BranchName", "MARGIN ", "TotalMargin", false, "Period", "", 1000, 2, AppColors, false, false, false, this.stacked);

					this.redrawChart();
				}
			})
		},

		redrawChart() {
            this.showchartcafe = false
            setTimeout(() => {
                this.showchartcafe = true
                //console.log('Redraw chart growth')
            }, 500);
        },

	}
}

</script>